module.exports = __webpack_public_path__ + "img/aig.533338de.jpg";